module.exports = __webpack_public_path__ + "static/media/refer.278c6e24.svg";